<template>
    <div class="ls-service-rec-or-req-details--container">
        <div>
            <div class="ls-service-rec-or-req-details--service">
                <LsServiceStatusIndicator :service="formattedRecOrReq" />
                <span class="ls-service-rec-or-req-details--service-name">{{
                    formattedRecOrReq.service.name
                }}</span>
                <LsServiceTypePill :service="formattedRecOrReq" />
            </div>
            <a
                class="ls-service-rec-or-req-details--pro"
                test-id="contractor"
                :href="oldAdminContractorLink"
                target="blank"
                >{{ contractorName }}</a
            >
        </div>
        <div>
            <LsInfoRowPricing :schedule="formattedRecOrReq" />
        </div>
        <div>
            <LsInfoRowStatus :service="formattedRecOrReq" />
        </div>
        <div>
            <LsInfoRowQuoteCompleted :schedule="formattedRecOrReq" />
        </div>
        <div>
            <LsInfoRowUpcoming :schedule="formattedRecOrReq" />
        </div>
        <div>
            <LsInfoRow
                :left-image="require('../LsServiceScheduleDetails/assets/frequency.svg')"
                label="Frequency"
                :value="0 | frequency"
            />
        </div>
        <div>
            <LsAdditionalDetails :schedule="formattedRecOrReq" />
        </div>
        <div>
            <p class="ls-service-rec-or-req-details--other-services">Other Services</p>
            <LsServiceList :services="services" :exclude="exclude" @click="handleClick" />
        </div>
    </div>
</template>

<script>
import VueTypes from 'vue-types';
import _ from 'lodash';
import { lsFilters } from 'ls-vue-common';
import LsServiceStatusIndicator from '@/components/LsServiceStatusIndicator/LsServiceStatusIndicator.vue';
import LsAdditionalDetails from '@/components/LsAdditionalDetails/LsAdditionalDetails.vue';
import LsInfoRowPricing from '@/components/LsInfoRowPricing/LsInfoRowPricing.vue';
import LsInfoRowQuoteCompleted from '@/components/LsInfoRowQuoteCompleted/LsInfoRowQuoteCompleted.vue';
import LsInfoRowStatus from '@/components/LsInfoRowStatus/LsInfoRowStatus.vue';
import LsInfoRowUpcoming from '@/components/LsInfoRowUpcoming/LsInfoRowUpcoming.vue';
import LsInfoRow from '@/components/LsInfoRow/LsInfoRow.vue';
import LsServiceList from '@/components/LsServiceList/LsServiceList.vue';
import LsServiceTypePill from '@/components/LsServiceTypePill/LsServiceTypePill.vue';

export default {
    name: 'LsServiceRecOrReqDetails',
    components: {
        LsServiceStatusIndicator,
        LsAdditionalDetails,
        LsInfoRowPricing,
        LsInfoRowUpcoming,
        LsInfoRow,
        LsServiceList,
        LsServiceTypePill,
        LsInfoRowQuoteCompleted,
        LsInfoRowStatus,
    },
    props: {
        recommendationOrRequired: VueTypes.shape({
            id: VueTypes.string.isRequired,
            __typename: VueTypes.oneOf(['Recommendation', 'RequiredService']).isRequired,
            schedule_at: VueTypes.string.isRequired,
            service: VueTypes.shape({
                name: VueTypes.string.isRequired,
            }).loose,
            contractor: VueTypes.shape({
                id: VueTypes.string.isRequired,
                name: VueTypes.string.isRequired,
                user: VueTypes.shape({
                    first_name: VueTypes.string.isRequired,
                    last_name: VueTypes.string.isRequired,
                }).loose,
            }).isRequired.loose,
        }).isRequired.loose,
        services: VueTypes.arrayOf(
            VueTypes.shape({
                id: VueTypes.string.isRequired,
                type: VueTypes.string,
            }).isRequired.loose
        ).isRequired,
    },
    computed: {
        formattedRecOrReq() {
            return {
                ...this.recommendationOrRequired,
                type: this.recommendationOrRequired.__typename,
                next_customer_starts_at: this.recommendationOrRequired.schedule_at,
            };
        },
        contractorName() {
            const { user, name } = this.formattedRecOrReq.contractor;

            return _.toUpper(`${name} - ${lsFilters.fullName({ user })}`);
        },
        exclude() {
            return [
                {
                    id: this.formattedRecOrReq.id,
                    __typename: this.formattedRecOrReq.__typename,
                },
            ];
        },
        oldAdminContractorLink() {
            return `${process.env.VUE_APP_ADMIN_BASE_URL}/contractors/${this.formattedRecOrReq.contractor.id}`;
        },
    },
    methods: {
        handleClick({ id, __typename }) {
            const routeName = _.camelCase(__typename);

            this.$router.push({
                name: routeName,
                params: {
                    customer_id: this.$route.params.customer_id,
                    property_id: this.$route.params.property_id,
                    [`${routeName}_id`]: id,
                },
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.ls-service-rec-or-req-details--container {
    padding: 30px 20px;
    border-radius: $border-radius;
    background-color: $white;
    display: flex;
    flex-direction: column;

    > div {
        padding: 15px 0;
        border-bottom: 1px solid $secondary-light;
    }

    div:first-child {
        padding-top: 0;
    }

    div:last-child {
        border: none;
        padding-bottom: 0;
    }
}

.ls-service-rec-or-req-details--service {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
}

.ls-service-rec-or-req-details--service-name {
    font-weight: $bold;
    padding: 1px 10px 0 10px;
    color: $secondary;
}

.ls-service-rec-or-req-details--pro {
    color: $primary;
    padding-left: 22px;
    cursor: pointer;
}

.ls-service-rec-or-req-details--other-services {
    font-weight: $bold;
    color: $secondary;
    margin-bottom: 10px;
}
</style>
